export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const KEY = '4766eb10-3f20-4677-a73b-1d7b8f96c7fa';
